import { withInstall } from '@tw-element/utils'

import Image from './src/image.vue'

export const TwImage = withInstall(Image)
export default TwImage

export * from './src/image'
